export const finalStates = new Set(['COMPLETED', 'FAILED', 'TERMINATED', 'CANCELED', 'CANCELLED', 'TIMED_OUT']);
